import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { computed, ref, PropType, Ref, watch, nextTick } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { uploadRunlog } from '@/api/evses'
import { ElInput } from 'element-plus'
import { ElMessage } from 'element-plus'
import useFormRules from '@/hooks/useFormRules'
import FormRulesFactory from '@/common/formRules'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseRunLogUpload',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  evse: {
    type: Object,
    default: () => {},
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const logFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['address'], 'inputEmpty', 'inputInvalid'),
})
const { t } = useI18n()




const createRawFormData = () => ({})

const showMapsDialog = ref(false)
const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())
const { createLetterStartRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const handleOpenLogDialog = () => {
  nextTick(() => {
    // 清空校验
    formCom.value.clearValidate()
    formData.value = {}
  })
}
const submit = async () => {
  try {
    await formCom.value.validate()
    isSubmitting.value = true
    formData.value.evseID = props.evse.id
    await uploadRunlog(formData.value)
    ElMessage.success(t(`Base.opSuccess`))
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SwitchLocaltionDialog = _resolveComponent("SwitchLocaltionDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElDialog), {
      modelValue: _unref(showDialog),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
      width: "65%",
      class: "upsert-dialog",
      title: _unref(t)('Base.diagnostics'),
      "z-index": 2000,
      onOpen: handleOpenLogDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit,
            disabled: !_ctx.$hasPermission('post'),
            loading: isSubmitting.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formCom",
          ref: formCom,
          "label-position": "top",
          "require-asterisk-position": "right",
          model: formData.value,
          rules: logFormRule.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Base.address'),
                      prop: "address",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInput), {
                          modelValue: formData.value.address,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.address) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Base.beginTime'),
                      prop: "beginTime"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: formData.value.beginTime,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.beginTime) = $event)),
                          type: "datetime",
                          "value-format": "YYYY-MM-DD HH:mm:ss",
                          placeholder: _ctx.$t('Base.beginTime'),
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Base.endTime'),
                      prop: "endTime"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: formData.value.endTime,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.endTime) = $event)),
                          type: "datetime",
                          "value-format": "YYYY-MM-DD HH:mm:ss",
                          placeholder: _ctx.$t('Base.endTime'),
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_SwitchLocaltionDialog, {
      modelValue: showMapsDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showMapsDialog).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})